import { defineMessages } from "react-intl";

export const messages = defineMessages({
  profileAlt: {
    id: "ads_manager.creative_preview.profile.alt",
    defaultMessage: "Profile",
    description: "Accessible description for the advertiser profile image in an ad preview.",
  },
  sponsoredLabel: {
    id: "ads_manager.creative_preview.sponsored",
    defaultMessage: "Sponsored",
    description: "Sponsored label shown in an ad preview.",
  },
  adLabel: {
    id: "ads_manager.creative_preview.ad",
    defaultMessage: "Ad",
    description: "Short disclosure badge shown in a compact ad review preview.",
  },
  advertiserFallbackName: {
    id: "ads_manager.creative_preview.advertiser.fallback_name",
    defaultMessage: "Company",
    description: "Fallback advertiser name shown while an ad account is unavailable.",
  },
});
